import React, { Fragment } from "react";
import styled from "styled-components";
import { Row, Col } from "react-bootstrap";

import { FORM_FIELD_KEYS } from "../../../../constants/forms";
import { getFieldProps } from "../../../../utils/form-fields";

import TextInput from "../../../controls/TextInput";
import MaskInput from "../../../controls/MaskInput";
import RadioGroup from "../../../controls/RadioGroup";
import Select from "../../../controls/Select";
import StyledButton from "../../../styled/StyledButton";

const StyledRow = styled(Row)`
  button {
    width: auto !important;

    &.remove-owner-button {
      background: #ffffff;
      border: 1px solid #c61f0c;
      color: #c61f0c;

      &:hover {
        background: #c61f0c;
        color: #ffffff;
      }
    }
  }
`;

function TrademarkOwnerInfoBlock({ values = {}, onChange, onAddOwner, onRemoveOwner }) {
  return (
    <StyledRow>
      <Col xs={12}>
        <div className="inputs-block-divider" />
      </Col>
      <Col xs={12}>
        <div className="inputs-block-title">
          <span>Owner of Trademark Name</span>
        </div>
      </Col>
      <Col xs={12}>
        <div className="input-title">
          <strong>Will the trademark be owned by an individual or an entity such as a corporation or LLC?</strong>
        </div>
      </Col>
      <Col xs={12}>
        <div className="input-title">
          <span>
            Identify the owner of the trademark. This is the person or organization who will be the owner of record. If
            you choose individuals, you can enter as many names as you want who own the mark. With an organization, you
            will have to identify someone to be the person of contact for the organization.
          </span>
        </div>
      </Col>
      <Col xs={12} md={values[FORM_FIELD_KEYS.individualOrgOrInd] === "Individual" ? 8 : 12}>
        <RadioGroup
          horizontal
          {...getFieldProps(FORM_FIELD_KEYS.individualOrgOrInd)}
          value={values[FORM_FIELD_KEYS.individualOrgOrInd]}
          onChange={onChange}
        />
      </Col>
      {values[FORM_FIELD_KEYS.individualOrgOrInd] === "Individual" && (
        <>
          <Col xs={12} md={4} className="d-flex justify-content-end">
            <StyledButton small secondary onClick={onAddOwner}>
              <span>+ Add owner</span>
            </StyledButton>
          </Col>
          {values?.coOwners?.map((coOwnerValues, idx) => (
            <Fragment key={`coOwner${idx}`}>
              <Col xs={12} md={6}>
                <TextInput
                  {...getFieldProps(FORM_FIELD_KEYS.firstName)}
                  id={`coOwners${idx}.${FORM_FIELD_KEYS.firstName}`}
                  placeholder="Enter First Name"
                  value={coOwnerValues[FORM_FIELD_KEYS.firstName]}
                  onChange={onChange}
                />
              </Col>
              <Col xs={12} md={6}>
                <TextInput
                  {...getFieldProps(FORM_FIELD_KEYS.lastName)}
                  id={`coOwners${idx}.${FORM_FIELD_KEYS.lastName}`}
                  placeholder="Enter Last Name"
                  value={coOwnerValues[FORM_FIELD_KEYS.lastName]}
                  onChange={onChange}
                />
              </Col>
              <Col xs={12} md={8} />
              <Col xs={12} md={4} className="d-flex justify-content-end">
                <StyledButton small secondary className="remove-owner-button" onClick={onRemoveOwner(idx)}>
                  <span>- Remove owner</span>
                </StyledButton>
              </Col>
            </Fragment>
          ))}
        </>
      )}
      {values[FORM_FIELD_KEYS.individualOrgOrInd] === "Organization" && (
        <>
          <Col xs={12} md={6} className="d-flex align-items-center">
            <div className="input-title">
              <strong>FORMATION:</strong>
            </div>
          </Col>
          <Col xs={12} md={6}>
            <RadioGroup
              horizontal
              {...getFieldProps(FORM_FIELD_KEYS.isNonUsBased)}
              value={values[FORM_FIELD_KEYS.isNonUsBased]}
              onChange={onChange}
            />
          </Col>
          <Col xs={12} md={6}>
            <TextInput
              {...getFieldProps(FORM_FIELD_KEYS.orgName)}
              value={values[FORM_FIELD_KEYS.orgName]}
              onChange={onChange}
              data-hj-allow
            />
          </Col>
          <Col xs={12} md={6}>
            <Select
              {...getFieldProps(FORM_FIELD_KEYS.orgType)}
              value={values[FORM_FIELD_KEYS.orgType]}
              validated={values.validated}
              onChange={onChange}
            />
          </Col>
          {values[FORM_FIELD_KEYS.orgType] === "Other" && (
            <Col xs={12}>
              <Select
                {...getFieldProps(FORM_FIELD_KEYS.otherOrgType)}
                value={values[FORM_FIELD_KEYS.otherOrgType]}
                validated={values.validated}
                onChange={onChange}
              />
            </Col>
          )}
          {values[FORM_FIELD_KEYS.isNonUsBased] === "USBased" && (
            <Col xs={12} md={6}>
              <Select
                {...getFieldProps(FORM_FIELD_KEYS.orgState)}
                value={values[FORM_FIELD_KEYS.orgState]}
                validated={values.validated}
                onChange={onChange}
              />
            </Col>
          )}
          {values[FORM_FIELD_KEYS.isNonUsBased] === "NonUSBased" && (
            <Col xs={12} md={6}>
              <Select
                {...getFieldProps(FORM_FIELD_KEYS.formationCountry)}
                value={values[FORM_FIELD_KEYS.formationCountry]}
                onChange={onChange}
                data-hj-allow
              />
            </Col>
          )}
          <Col xs={12} md={6}>
            <TextInput
              {...getFieldProps(FORM_FIELD_KEYS.orgPosition)}
              value={values[FORM_FIELD_KEYS.orgPosition]}
              onChange={onChange}
              data-hj-allow
            />
          </Col>
        </>
      )}
      <Col xs={12} md={6}>
        <TextInput
          {...getFieldProps(FORM_FIELD_KEYS.firstName)}
          placeholder="Enter First Name"
          value={values[FORM_FIELD_KEYS.firstName]}
          onChange={onChange}
        />
      </Col>
      <Col xs={12} md={6}>
        <TextInput
          {...getFieldProps(FORM_FIELD_KEYS.lastName)}
          placeholder="Enter Last Name"
          value={values[FORM_FIELD_KEYS.lastName]}
          onChange={onChange}
        />
      </Col>
      {values[FORM_FIELD_KEYS.individualOrgOrInd] !== "Organization" &&
        <Col xs={12}>
          <Select
            {...getFieldProps(FORM_FIELD_KEYS.countryOfCitizenship)}
            value={values[FORM_FIELD_KEYS.countryOfCitizenship]}
            label="Country of Citizenship"
            validated={values.validated}
            onChange={onChange}
          />
        </Col>
      }
      <Col xs={12}>
        <TextInput
          {...getFieldProps(FORM_FIELD_KEYS.address)}
          isCorpAddress
          label="Address"
          placeholder="Enter Address"
          pattern={`(?!.*(?:[pP][oO] [bB][oO][xX]))^[ a-zA-Z0-9\\\\\\/\\-]+$`}
          defaultInvalidMessage="The only special characters allowed in the Street field are - and /. PO Boxes are not acceptable."
          value={values[FORM_FIELD_KEYS.address]}
          onChange={onChange}
        />
      </Col>
      <Col xs={12} md={6}>
        <TextInput
          {...getFieldProps(FORM_FIELD_KEYS.city)}
          label="City"
          placeholder="Enter City"
          value={values[FORM_FIELD_KEYS.city]}
          onChange={onChange}
        />
      </Col>
      <Col xs={12} md={6}>
        <Select
          {...getFieldProps(FORM_FIELD_KEYS.state)}
          value={values[FORM_FIELD_KEYS.state]}
          label="State / Province"
          validated={values.validated}
          onChange={onChange}
        />
      </Col>
      <Col xs={12} md={6}>
        <TextInput
          {...getFieldProps(FORM_FIELD_KEYS.zip)}
          label="Zip / Postal Code"
          value={values[FORM_FIELD_KEYS.zip]}
          onChange={onChange}
        />
      </Col>
      <Col xs={12} md={6}>
        <MaskInput
          {...getFieldProps(FORM_FIELD_KEYS.phone)}
          value={values[FORM_FIELD_KEYS.phone]}
          onChange={onChange}
        />
      </Col>
      <Col xs={12}>
        <TextInput
          {...getFieldProps(FORM_FIELD_KEYS.email)}
          placeholder="Enter Email Address"
          loading={values.verifying}
          value={values[FORM_FIELD_KEYS.email]}
          onChange={onChange}
        />
      </Col>
    </StyledRow>
  );
}

export default TrademarkOwnerInfoBlock;
